import React, { useEffect, useState } from 'react';
import { Logo, GradientBackground } from '../components/ui';

const floaters = [
  { icon: '🧹', x: '12%', delay: 0 },
  { icon: '🍳', x: '80%', delay: 0.4 },
  { icon: '🧺', x: '25%', delay: 0.9 },
  { icon: '👶', x: '70%', delay: 1.3 },
  { icon: '🧽', x: '50%', delay: 0.7 },
];

// Brand splash — drifting service chips, a sweeping broom, then auto-dismiss.
export default function SplashScreen({ onDone }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setLeaving(true);
      setTimeout(() => onDone && onDone(), 450);
    }, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, opacity: leaving ? 0 : 1, transition: 'opacity 0.45s ease' }}>
      <style>{`
        @keyframes splash-float { 0% { transform: translateY(60px); opacity: 0; }
          25% { opacity: 0.9; } 100% { transform: translateY(-40px); opacity: 0; } }
        @keyframes broom-sweep { 0%, 100% { transform: rotate(-22deg); } 50% { transform: rotate(18deg); } }
        @keyframes twinkle { 0%, 100% { opacity: 1; } 50% { opacity: 0.2; } }
        @keyframes pop-in { from { transform: scale(0.6); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes dot-pulse { 0%, 100% { opacity: 0.3; } 50% { opacity: 1; } }
      `}</style>

      <GradientBackground>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
          {floaters.map((f) => (
            <div
              key={f.icon}
              style={{
                position: 'absolute', top: '55%', left: f.x,
                width: 44, height: 44, borderRadius: 14,
                background: 'rgba(255,255,255,0.14)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22,
                animation: `splash-float 3.2s ${f.delay}s ease-in-out infinite`,
              }}
            >
              {f.icon}
            </div>
          ))}

          <div style={{ animation: 'pop-in 0.6s cubic-bezier(0.22,1,0.36,1) both' }}>
            <Logo size="lg" animated={false} />
          </div>

          {/* House + maid scene */}
          <div style={{ margin: '34px 0 26px', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ position: 'absolute', left: -6, top: -6, fontSize: 20, animation: 'twinkle 1.2s infinite' }}>✨</span>
            <span style={{ position: 'absolute', right: -4, top: 4, fontSize: 20, animation: 'twinkle 1.2s 0.3s infinite' }}>✨</span>
            <span style={{ fontSize: 74 }}>🏠</span>
            <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: -6 }}>
              <span style={{ fontSize: 40 }}>👩‍🔧</span>
              <span style={{ fontSize: 34, marginLeft: -4, display: 'inline-block', animation: 'broom-sweep 1.4s ease-in-out infinite', transformOrigin: 'bottom center' }}>🧹</span>
            </div>
          </div>

          <div style={{ textAlign: 'center', animation: 'pop-in 0.5s 0.4s both' }}>
            <div style={{ color: '#fff', fontSize: 24, fontWeight: 800, letterSpacing: 0.3 }}>Trusted Home Help</div>
            <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: 14, marginTop: 8, lineHeight: 1.45 }}>
              Verified maids, cooks &amp; caretakers<br />at your doorstep
            </div>
          </div>

          <div style={{ position: 'absolute', bottom: 60, display: 'flex', gap: 8 }}>
            {[0, 1, 2].map((i) => (
              <span key={i} style={{ width: 9, height: 9, borderRadius: 999, background: '#fff', animation: `dot-pulse 0.8s ${i * 0.15}s infinite` }} />
            ))}
          </div>
        </div>
      </GradientBackground>
    </div>
  );
}
